export const QA_NAME_PROFILE_FINISHED_WIDGET_RATING_BUTTON =
  'profile_finished_widget_rating_button'

export const PROFILE_FINISHED_WIDGET_RATING_BUTTON_QA_STATE = {
  add: 'add',
  edit: 'edit',
}
